import { getKeyByValue } from "utils/objects";

// Storing logged-in user info
const USER_INFO_KEY = '__awc__';

// Storing authentication token
const AUTH_TOKEN_KEY = '__awc_auth__';

// Components unique nomencalture
const DESIGNATION_MANAGEMENT = 'designation_management';
const EMPLOYEE_MANAGEMENT = 'employee_management';
const TEAM_MANAGEMENT = 'team_management';
const SHIFT_MANAGEMENT = 'shift_management';
const WFH_MANAGEMENT = 'wfh_management';
const HOLIDAY_MANAGEMENT = 'holiday_management';
const ROLE_MANAGEMENT = 'role_management';
const ATTENDANCE_MANAGEMENT = 'attendance_management';
const ANALYTICS_MANAGEMENT = 'analytics_management';
const PROFILE_MANAGEMENT = 'profile_management';
const SETTING_MANAGEMENT = 'setting_management';
const SEARCH_MANAGEMENT = 'search_management';
const PAYROLLNOTE_MANAGEMENT = 'payrollnote_management';
const MAIL_MANAGEMENT = 'mail_management';
const REQUEST_LEAVE_MANAGEMENT = 'rleave_management';

// Permissions
const ACCEPTED_PERMISSIONS = {
    "create": "CREATE",
    "read": "READ",
    "update": "UPDATE",
    "delete": "DELETE",
};

const SUPPORTED_DATE_FORMATS = [
    'yyyy-MM-dd',
    'dd-MM-yyyy',
    'MM/dd/yyyy',
    'dd/MM/yyyy',
    'yyyy/MM/dd',
];

const SUPPORTED_DASHBOARDS = {
    ADMIN: 'admin_mnj-d4768d43-1252-4a86-8a09-52c9ee4658e1', 
    EMPLOYEE: 'employee_mnj-9f55d370-7cc6-4b13-90bf-94c72f27f92d',
};

const LEAVE_TYPES = {
  sick: "Sick",
  paternity: "Paternity",
  maternity: "Maternity",
  casualFullDay: "Casual - Full Day",
  casualHalfDay: "Casual - Half Day",
  other: "Other",
};

const NOT_REQUIRE_END_DATE = [
  getKeyByValue(LEAVE_TYPES, LEAVE_TYPES.casualHalfDay),
];

const LEAVE_STATUS = {
  pending: "Pending",
  approved: "Approved",
  rejected: "Rejected",
};

const RECORDING_INTERVAL_MS = 1 * 60 * 1000;
const RECORDING_FREQUENCY_MIN_SECONDS = 1;
const RECORDING_FREQUENCY_MAX_SECONDS = 4 * 60 * 60;
const RECORDING_MODES = {
  interval: 'interval',
  continuous: 'continuous',
};
const CONTINUOUS_CHUNK_MS = 3 * 60 * 1000;
const RECORDING_UPLOAD_MAX_ATTEMPTS = 5;
const RECORDING_CLIP_MS = 60 * 1000;
const RECORDING_SLOT_TOLERANCE_MS = 2 * 60 * 1000;
const RECORDING_HEARTBEAT_MS = 15 * 1000;
const SCREEN_SHARE_REMINDER_MS = 2 * 60 * 1000;
const CAPTURE_SESSION_STORAGE_KEY = 'hrms_capture_session_id';
const RECORDING_TAB_LOCK = 'hrms-screen-recording';
const RECORDING_TAB_STORAGE_KEY = 'hrms_recording_tab_id';
const RECORDING_CLIPS_PAGE_SIZE = 6;

export {
    USER_INFO_KEY,
    AUTH_TOKEN_KEY,
    DESIGNATION_MANAGEMENT,
    TEAM_MANAGEMENT,
    SHIFT_MANAGEMENT,
    WFH_MANAGEMENT,
    ATTENDANCE_MANAGEMENT,
    ANALYTICS_MANAGEMENT,
    ROLE_MANAGEMENT,
    HOLIDAY_MANAGEMENT,
    EMPLOYEE_MANAGEMENT,
    PROFILE_MANAGEMENT,
    SETTING_MANAGEMENT,
    SEARCH_MANAGEMENT,
    ACCEPTED_PERMISSIONS,
    SUPPORTED_DATE_FORMATS,
    SUPPORTED_DASHBOARDS,
    PAYROLLNOTE_MANAGEMENT,
    MAIL_MANAGEMENT,
    REQUEST_LEAVE_MANAGEMENT,
    LEAVE_TYPES,
    NOT_REQUIRE_END_DATE,
    LEAVE_STATUS,
    RECORDING_INTERVAL_MS,
    RECORDING_FREQUENCY_MIN_SECONDS,
    RECORDING_FREQUENCY_MAX_SECONDS,
    RECORDING_MODES,
    CONTINUOUS_CHUNK_MS,
    RECORDING_UPLOAD_MAX_ATTEMPTS,
    RECORDING_CLIP_MS,
    RECORDING_SLOT_TOLERANCE_MS,
    RECORDING_HEARTBEAT_MS,
    SCREEN_SHARE_REMINDER_MS,
    CAPTURE_SESSION_STORAGE_KEY,
    RECORDING_TAB_LOCK,
    RECORDING_TAB_STORAGE_KEY,
    RECORDING_CLIPS_PAGE_SIZE,
}